import { introducingBrokerDefaultParams } from "_constants";
import { useCallback, useState } from "react";

export const useIntroducingBrokerFilters = () => {
  const [params, setParams] = useState(introducingBrokerDefaultParams);

  const onParamsChange = useCallback((value) => {
    setParams(value);
  }, []);

  return { params, onParamsChange };
};
